import { $tenant, useApiClient, useAsyncCache } from '@msdk/common'
import { readUserData, TenantPath } from '@msdk/definitions'
import { useEffect, useState } from 'react'
import { useRecoilValue } from 'recoil'

export function useUserDialysisMachineSignedIn(openNGID: boolean) {
  const [result, setResult] = useState<boolean | undefined>(undefined)
  const [startIndex, setStartIndex] = useState<number | undefined>(undefined)
  const client = useApiClient()
  const cache = useAsyncCache()
  const tenant = new TenantPath()
  const tenantId = useRecoilValue($tenant)
  const userId = readUserData().user_id
  // const buId = readUserData().business_unit
  // const isModalSkippedKey = `SKIP_MODAL_NGID_${tenantId}_${buId}_${userId}`
  const isModalSkippedKey = `SKIP_MODAL_NGID_${tenantId}_${userId}`
  const isNGIDEnabled = tenant.IsCustomizationEnabled('NGID')
  useEffect(() => {
    const fetchdata = async () => {
      if (!isNGIDEnabled) {
        setResult(true)
        return
      }
      // eslint-disable-next-line @typescript-eslint/no-shadow
      const isModalSkipped = localStorage.getItem(isModalSkippedKey) ?? false
      const res = await cache.getOrCreate(`isUserDialysisMachineSignedIn`, () =>
        client.read<boolean>(`USM/api/NGID/IsPasscodePresent`),
      )
      if (typeof res === 'boolean') {
        setResult(isModalSkipped === 'true' && !openNGID ? true : openNGID ? false : res)
        //setStartIndex(await updateStartIndex())
        setStartIndex(res ? 3 : 0)
      }
    }
    fetchdata().catch(console.error)
  }, [])

  const onClose = () => {
    //localStorage.setItem(isModalSkippedKey, 'true')
    if (!openNGID) {
      window.location.reload()
    }
  }

  const updateStartIndex = async (): Promise<number> => {
    const res = await cache.getOrCreate(`isUserDialysisMachineSignedIn`, () =>
      client.read<boolean>(`USM/api/NGID/IsPasscodePresent`),
    )
    return res ? 3 : 0
  }

  return { result, onClose, startIndex, updateStartIndex }
}
